module.exports = __webpack_public_path__ + "static/img/a6.d40847d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/a6.png
// module id = DeJE
// module chunks = 0